import {fetchWithState, getFetchedJSON} from '~/misc/fetch';

export const verifyEmail = (getState) =>
  fetchWithState(getState, {
    method: 'GET',
    url: '/tl/users/send-verify-email',
  }).then(getFetchedJSON);


export const sendPhoneVerifyCode = (getState, phoneNumber) => 
  fetchWithState(getState, {
    method: 'POST',
    url: `/tp/user/send/invitation/code?areacode=1&phoneNo=${phoneNumber}`,
  }).then(getFetchedJSON);

export const verifyPhone = (getState, phoneNumber, code) => 
  fetchWithState(getState, {
    method: 'POST',
    url: `/tp/user/validate/invitation/code?code=${code}&phoneNo=${phoneNumber}`,
  }).then(getFetchedJSON);

  export const verifyPhoneFromEmail = (getState, phoneNumber, code) => 
  fetchWithState(getState, {
    method: 'POST',
    url: `/tp/user/validate/invitation/code?code=${code}&phoneNo=${phoneNumber}&source=Email-Campaign`,
  }).then(getFetchedJSON);



// WEBPACK FOOTER //
// ./src/modules/verify/api.js